<script module lang="ts">
  import type { Product } from '@agapi/mlc-core';

  export interface Props {
    product: Product;
  }
</script>

<script lang="ts">
  import { css } from '@agapi/ui/panda/css';
  import { Section } from '@agapi/ui/section';
  import { Breadcrumb, BreadcrumbItem } from '@agapi/ui/breadcrumb';
  import { BreadcrumbsSchema } from '../../../components';
  import { rewriteUrl } from '../../../utils';
  import { page } from '$app/state';

  const { product }: Props = $props();
</script>

<!-- Bread crumbs -->
<Section
  rootStyles={css.raw({
    pt: { base: 'calc(token(spacing.2) + token(spacing.5))', sm: 3! },
    pb: { base: 3!, md: 5! }
  })}
>
  {#if product.breadcrumbs.length > 0}
    <BreadcrumbsSchema
      items={product.breadcrumbs.map((breadcrumb) => ({
        name: breadcrumb.title,
        item: rewriteUrl(page, breadcrumb.fullSlug)
      }))}
    />
    <Breadcrumb>
      {#each product.breadcrumbs?.slice(1) as breadcrumb, index}
        <BreadcrumbItem {index}>
          <a
            href={rewriteUrl(
              page,
              index > 0 ? '/' + breadcrumb.fullSlug.split('/').slice(2).join('/') : undefined
            )}
          >
            {breadcrumb.title}
          </a>
        </BreadcrumbItem>
      {/each}
      <BreadcrumbItem index={product.breadcrumbs.length}>
        {product.name?.slice(0, 70)}
        {#if product.name?.length > 70}
          ...
        {/if}
      </BreadcrumbItem>
    </Breadcrumb>
  {/if}
</Section>
